import { Link, NavLink, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import AuthUtility from '../frontend/auth/AuthUtility';
import { useAudio } from '../../context/AudioProvider';

import logo from '../../assets/frontend/images/logo.png';
import podcast_icon_image from '../../assets/frontend/images/podcast_icon.png';

const LIKE_KEY = 'romergence_liked_tracks';

const AlbumsPanel = ({ onClose, track, tracklist }) => {

  const navHistory = useNavigate();
  // using hooks
  const [hasLikedTracks, setHasLikkedTracks] = useState(false);

  const { likedMap } = useAudio();

  const safeLikedMap = likedMap || [];

  useEffect(() => {

    const likedTracksArray =
      Array.isArray(safeLikedMap.tracks)
        ? safeLikedMap.tracks
        : []; // normalize
    if (likedTracksArray.length > 0) {
      setHasLikkedTracks(true);
    }
  }, [safeLikedMap]);

  function handleAlbum(title_private, type) {
    if (!title_private || title_private === '' || !type || type === '') {
      return;
    }
    if (AuthUtility.isLoggedIn()) {
      navHistory('/member/album/' + title_private + '/' + type);
    } else {
      //user not authenticated on server so remove from local storage
      AuthUtility.clearAuthData();
      navHistory('/album/' + title_private + '/' + type);
    }
    onClose();
  }

  return (
    <div className="options-content">
      <div className="panel large p-20l-10s">
        <div className="horizontal-container justify-left gap-lg-md bb1-555 pb-10l-5s">
          <span className="center-everything">
            <span className="font-source-sans font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">Albums & Playlists</span>
          </span>
          <span className="align-right">
            <Link className="font-poppins font-size-18l-16m font-weight-500" onClick={onClose}>Close</Link>
          </span>
        </div>

        <div className="grid-x">

          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5" onClick={() => handleAlbum('to_infinity', 'album')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-source-sans font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    To Infinity
                  </div>
                </div>
              </div>
              <img src={podcast_icon_image} className="b1-555 hide-for-small-only" alt="romergence image" width="100%" />
              <img src={podcast_icon_image} className="b1-555 show-for-small-only" alt="romergence image" width="100%" />
            </div>
            <div className="pt-10 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('to_infinity', 'album')}>
                Album
              </button>
            </div>
          </div>
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5l-0m pl-0l-5m" onClick={() => handleAlbum('fragments_of_the_mind', 'album')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-source-sans font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    Framents Of
                    <div className='pt-10l-5m'></div>
                    The Mind
                  </div>
                </div>
              </div>
              <img src={podcast_icon_image} className="b1-555 hide-for-small-only" alt="romergence image" width="100%" />
              <img src={podcast_icon_image} className="b1-555 show-for-small-only" alt="romergence image" width="100%" />
            </div>
            <div className="pt-10 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('fragments_of_the_mind', 'album')}>
                Album
              </button>
            </div>
          </div>
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5l-0m" onClick={() => handleAlbum('rise_&_fall', 'demos')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-source-sans font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">Rise & Fall</div>
                </div>
              </div>
              <img src={podcast_icon_image} className="b1-555 hide-for-small-only" alt="romergence image" width="100%" />
              <img src={podcast_icon_image} className="b1-555 show-for-small-only" alt="romergence image" width="100%" />
            </div>
            <div className="pt-10 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('rise_&_fall', 'demos')}>
                Demos
              </button>
            </div>
          </div>
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5" onClick={() => handleAlbum('to_infinity_&_back', 'album')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-source-sans font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    To Infinity
                    <div className='pt-10l-5m'></div>
                    & Back
                  </div>
                </div>
              </div>
              <img src={podcast_icon_image} className="b1-555 hide-for-small-only" alt="romergence image" width="100%" />
              <img src={podcast_icon_image} className="b1-555 show-for-small-only" alt="romergence image" width="100%" />
            </div>
            <div className="pt-10 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('to_infinity_&_back', 'album')}>
                Album
              </button>
            </div>
          </div>
          {hasLikedTracks && (
          <div className="large-3 medium-4 small-6 cell album-hover hover-opacity-75 ptb-15l-12s plr-5" onClick={() => handleAlbum('liked_songs_demos', 'liked')}>
            <div className="text-overlay-wrapper text-center">
              <div className="text-overlay-1020-bottom50">
                <div className="position-align-bottom pb-10 text-center">
                  <div className="font-source-sans font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                    Liked Songs
                    <div className='pt-10l-5m'></div>
                    & Demos
                  </div>
                </div>
              </div>
              <img src={logo} className="b1-555 hide-for-small-only" alt="romergence image" width="100%" />
              <img src={logo} className="b1-555 show-for-small-only" alt="romergence image" width="100%" />
            </div>
            <div className="pt-10 text-center">
              <button className="button small width-80pxl-70pxm-80pxs plr-20"
                onClick={() => handleAlbum('liked_songs_demos', 'liked')}>
                Liked
              </button>
            </div>
          </div>
          )}
        </div>

        <div className="horizontal-container justify-right bt1-555 ptb-10 pr-10">
          <Link className="font-poppins font-size-18l-16m font-weight-500" onClick={onClose}>Close</Link>
        </div>
      </div>
    </div>
  );
};

export default AlbumsPanel;
